import Alpine from 'alpinejs';
import headerScroll from './header-scroll.js';

window.Alpine = Alpine;

// Make header scroll component available globally
window.headerScroll = headerScroll;

Alpine.start();

// Prevent right-click on the page
document.addEventListener( 'contextmenu', function ( e ) {
	e.preventDefault();
	e.stopPropagation();
} );
